import React from 'react';
import {
    Container,
    Divider,
    Dropdown,
    Grid,
    Header,
    Image,
    List,
    Menu,
    Segment
} from 'semantic-ui-react';

const Footer = () => (
    <Segment
        inverted
        vertical
        style={{ margin: '0em 0em 0em', padding: '5em 0em' }}
    >
        <Container textAlign="center">
            <Grid divided inverted stackable>
                <Grid.Row>
                    <Grid.Column width={4}>
                        <Header inverted as="h4" content="Social media" />
                        <div align="center">
                            <List link inverted>
                                <List.Item>
                                    <List.Icon name="facebook" />
                                    <List.Content>
                                        <a href="https://www.facebook.com/bogdan.sebeni.9">
                                            {' '}
                                            Facebook
                                        </a>
                                    </List.Content>
                                </List.Item>

                                <List.Item>
                                    <List.Icon name="instagram" />
                                    <List.Content>
                                        <a href="https://www.instagram.com/mastermind.brasov/">
                                            {' '}
                                            Instagram
                                        </a>
                                    </List.Content>
                                </List.Item>

                                <List.Item>
                                    <List.Icon name="linkedin" />
                                    <List.Content>
                                        <a href="http://www.linkedin.com/in/bogdan-sebeni-407b38b1/">
                                            {' '}
                                            LinkedIn
                                        </a>
                                    </List.Content>
                                </List.Item>

                                <List.Item>
                                    <List.Icon name="twitter square" />
                                    <List.Content>
                                        <a href=""> Twitter</a>
                                    </List.Content>
                                </List.Item>
                            </List>
                        </div>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Header inverted as="h4" content="Personal Blog" />
                        <List link inverted>
                            <List.Item>
                                <List.Content>
                                    <a href="https://medium.com/@bogdan.sebeni">
                                        {' '}
                                        Medium
                                    </a>
                                </List.Content>
                            </List.Item>
                            <List.Item as="a" />
                            <List.Item as="a" />
                            <List.Item as="a" />
                        </List>
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Header inverted as="h4" content="Others" />
                        <List link inverted>
                            <List.Item as="a">Tel: +40 724 729 394</List.Item>
                            <List.Item as="a" />
                            <List.Item as="a" />
                            <List.Item as="a" />
                        </List>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </Segment>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js